import React, { useCallback, useState } from 'react'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import { RECEIPTS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import QuickLinkService from '../../services/quick-link.service'

export default function TransferReceipts({ dataSource = [] }) {
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()

  const getDownload = useCallback(async (selected) => {
    try {
      //   setLoading(true)
      const reqParams = {
        transRefNum: selected.transactionRef,
        refId: selected.receiptId,
        module: 'FUNDTRANSFER',
      }
      await QuickLinkService.pdfReceipt(reqParams)
      //   setLoading(false)
    } catch (err) {
      //   setLoading(false)
    }
  }, [])

  const getTransferType = useCallback((transferType) => {
    switch (transferType) {
      case 'OAT':
        return t(RECEIPTS_KEYS.OAT)
      case 'RTGS':
        return t(RECEIPTS_KEYS.RTGS)
      case 'IAT':
        return t(RECEIPTS_KEYS.IAT)
      case 'SWIFT':
        return t(RECEIPTS_KEYS.SWIFT)
      case 'DDACC':
        return t(RECEIPTS_KEYS.DDACC)
    }
  }, [])

  return (
    <>
      <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
        {dataSource.map((item, index) => (
          <div
            key={index}
            className='loan-card '
            onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
            <div className='loan-header'>
              <div>
                <span>
                  {t(RECEIPTS_KEYS.REF_ID)} : {item.transactionRef}
                </span>
                <div style={{ display: 'flex' }}>
                  <span>{t(RECEIPTS_KEYS.TRANSACTION_DATE)}: </span>
                  <span style={{ marginLeft: 5 }}>
                    {moment(item.transTime).format('DD-MM-YYYY')} &nbsp;{''}
                    {moment(item.transTime).format('HH:MM:SS')}
                  </span>
                </div>
              </div>
              <div>
                <div className='d-flex' style={{ justifyContent: 'end' }}>
                  <label style={{ fontSize: '6px' }}>
                    {JSON.parse(item?.reqObj)?.fin?.txnCurrency ||
                      JSON.parse(item?.reqObj)?.fin?.srcAccCcy}
                  </label>
                  &nbsp;
                  <NumberFormat
                    value={JSON.parse(item?.reqObj)?.fin?.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    prefix={''}
                    className='float-right'
                    fixedDecimalScale={true}
                    allowEmptyFormatting
                  />
                </div>
                <div>
                  <span>{getTransferType(JSON.parse(item?.reqObj)?.nfin?.transferType)}</span>
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row beneficiary-details justify-space-between '>
                  <div className='col-12'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.FROM_ACCOUNT)}</div>
                        <div className='value'>{JSON.parse(item?.reqObj)?.fin?.srcAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.TO_ACCOUNT)}</div>
                        <div className='value'>{JSON.parse(item?.reqObj)?.fin?.destAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.TRANSACTION_DATE)}</div>
                        <div className='value'>
                          {moment(item.transTime || '-').format('DD-MM-YYYY')} &nbsp;{' '}
                          {moment(item.transTime || '-').format('HH:MM:SS')}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.TRANS_CURRENCY)}</div>
                        <div className='value'>
                          {JSON.parse(item?.reqObj)?.fin?.txnCurrency ||
                            JSON.parse(item?.reqObj)?.fin?.srcAccCcy}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.BENE_NAME)}</div>
                        <div className='value'>
                          {JSON.parse(item?.reqObj)?.nfin?.beneficiaryName}
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.AMOUNT)}</div>
                        <div className='d-flex value'>
                          <NumberFormat
                            value={JSON.parse(item?.reqObj)?.fin?.amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </div>
                      </div>

                      <div className='col-5'>
                        <div className='label'>{t(RECEIPTS_KEYS.TRANFER_TYPE)}</div>
                        <div className='value'>
                          {getTransferType(JSON.parse(item?.reqObj)?.nfin?.transferType)}
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className='label'>{t(RECEIPTS_KEYS.REMARKS)}</div>
                        <div className='value'>{JSON.parse(item?.reqObj)?.fin?.remarks}</div>
                      </div>
                    </div>

                    <div class='row'>
                      <h6
                        className='download-link'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          getDownload(item)
                        }}>
                        {t(RECEIPTS_KEYS.DOWNLOAD)}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}
